export const absoluteCenter: React.CSSProperties = {
  position: "absolute",
  left: "50%",
  transform: "translateX(-50%)",
};
